import { render, staticRenderFns } from "./RecallFAQ.vue?vue&type=template&id=a64a8c38&scoped=true&"
import script from "./RecallFAQ.vue?vue&type=script&lang=js&"
export * from "./RecallFAQ.vue?vue&type=script&lang=js&"
import style0 from "./RecallFAQ.vue?vue&type=style&index=0&id=a64a8c38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64a8c38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VContainer,VFlex,VLayout})
